// React
import React, { Component } from 'react';
import Alert from 'react-s-alert';
import {GetApp, Assignment} from '@material-ui/icons/';
import {functions} from 'constants/index';
import {ButtonGroup} from '@material-ui/core/';
// Api Services
import ApiServices from 'services/ApiServices';
// Redux
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
// componentes
import Table from 'components/Table';
import Footer from 'pages/Home/Footer2';
import ListElement from './ListElement';
import BotonElement from 'components/BotonTable'; 
import LoadingSpinner from 'components/LoadingSpinner';
import CustomToolTip from 'components/tooltip/';
import DialogLoadingMessage from 'components/BackDrop';
import ComponenteDescargarConstanciaEmergencia from 'pages/GeoEmpadronamiento/SolicitudesDeEmpadronamiento/SolicitudesEnviadas/DescargarConstanciaDeInscripcionActualizacion'

class SolicitudesEnviadas extends Component {     
    constructor(props) {
        super(props);
        this.state = {
            controller:'solicitudesDeEmpadronamiento',
            SOLICITUD_EMPADRONAMIENTO_SET_DATOS_IDENTIDAD: props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_IDENTIDAD,
            loading: false,
            authorized:true,
            checkAutorization:true,
            aceptarOpen: false,
            rechazarOpen: false,
            newCve:"",
            abrirModalRechazoSolicitud: false,
            datosPadron:{},
            rowData: [],
            data: [],
            customActions:[],
            origenSolicitud:'',
            descargarConstanciaDeEmpadronamientoEmergencia:false,
            saveDataDescargarConstancia: {},
            loadingMessage:{loading:false, title:''},
            header: [
                { title: 'Solicitud No.', field: 'datosSolicitudEmpadronamiento.idSolicitud',cellStyle:{ maxWidth: '80px' } },
                { title: 'Nombre Completo', field: 'nombreCompleto', cellStyle:{ maxWidth: '100px' }, filtering: false},
                { title: 'CUI', field: 'datosDpiSolicitudEmpadronamiento.cui' },
                { title: 'Pais Residencia', field: 'datosSolicitudEmpadronamiento.descripcionPaisResidencia.nombrePaisCorto', filtering: false },
                { title: 'Estado Residencia', field: 'datosSolicitudEmpadronamiento.nombreDelEstado', filtering: false},
                { title: 'Ciudad Residencia', field: 'datosSolicitudEmpadronamiento.nombreDelaCiudad', filtering: false},
                { title: 'Departamento Residencia', field: 'departamentoResidencia.name'},
                { title: 'Municipio Residencia', field: 'municipioResidencia.name',},
                { title: 'Puesto de Empadronamiento', field: 'puestoEmpadronamiento.nombrePuesto',filtering: false },
                { title: 'Fecha modificó', field: 'datosSolicitudEmpadronamiento.fechaFueModificada', filtering: true},
                // { title: 'Fecha modificó', field: 'datosSolicitudEmpadronamiento.fechaFueModificada', render: (rowData) => functions.splitDate(rowData.datosSolicitudEmpadronamiento.fechaFueModificada)},
                { title: 'Hora modificó', field: 'datosSolicitudEmpadronamiento.horaFueModificada', filtering: false},
                { title: 'Usuario modificó', field: 'datosSolicitudEmpadronamiento.usuarioMod'},
                { title: 'Origen', field: 'datosSolicitudEmpadronamiento.tipoOrigen'},
                { title: 'Nacional / Extranjero', field: 'datosSolicitudEmpadronamiento.nacionalExtranjero', filtering: false},                
                { title: 'Tipo Solicitud', field: 'datosSolicitudEmpadronamiento.tipoSolicitud',},
                { title: 'Fecha solicitud', field: 'datosSolicitudEmpadronamiento.fechaParseada', filtering: false},
                // { title: 'Fecha solicitud', field: 'datosSolicitudEmpadronamiento.fechaSolicitud', render: (rowData) => functions.splitDate(rowData.datosSolicitudEmpadronamiento?.fechaSolicitud),},
                { title: 'Fecha de Inscripción/Actualización', field: 'datosSolicitudEmpadronamiento.fechaFueModificada', filtering: false},
                // { title: 'Fecha de Inscripción/Actualización', field: 'datosSolicitudEmpadronamiento.fechaMod', render: (rowData) => functions.splitDate(rowData.datosSolicitudEmpadronamiento?.fechaMod),},
                { title: 'Archivo', field: 'accion', filtering: false,               
                    render: rowData=><div style={{minWidth: '200px'}}>
                    {
                        (rowData.datosSolicitudEmpadronamiento?.statusSolicitud === 1) ? (
                            <ButtonGroup color="primary" aria-label="outlined primary button group">
                                {
                                    (this.props.currentUser?.rol?.name === "GEO-ADMIN") ?
                                        <BotonElement icon={<GetApp />} title="Descargar Solicitud" 
                                            function={async () => {
                                                this.setState({loadingMessage: {loading: true, title: 'Descargando solicitud ...'}})
                                                var datos = {document: "solicitud", id: rowData.datosSolicitudEmpadronamiento?.idSolicitud}
                                                let response = await ApiServices[this.state.controller].openFile(datos);
                                                if (response.error != null) Alert.error("Intente de nuevo");
                                                else
                                                functions.downloadPDFFromStringBase64(response.data.base64, "Solicitud de Empadronamiento.pdf");
                                                this.setState({loadingMessage: {loading: false, title: ''}})
                                            }}                            
                                        />: ''
                                }
                                <BotonElement icon={<GetApp />} title="Descargar Constancia Empadronamiento" 
                                    function={async () => {
                                        this.setState({loadingMessage: {loading: true, title: 'Descargando constancia ...'}})
                                        var datos = {document: "constancia", id: rowData.datosSolicitudEmpadronamiento?.idSolicitud}
                                        let response = await ApiServices[this.state.controller].openFile(datos);
                                        if (response.error != null) Alert.error("Intente de nuevo");
                                        else
                                        functions.downloadPDFFromStringBase64(response.data.base64, "Constancia de Empadronamiento.pdf");
                                        this.setState({loadingMessage: {loading: false, title: ''}})
                                    }}                            
                                />
                                <CustomToolTip title="Descargar Constancia Emergencia" handleFunction={() => this.openDialogDownloadConstancyOfInscripcionActualizacion(rowData)}><Assignment/></CustomToolTip>
                            </ButtonGroup>
                        ) 
                        : ''
                    }  
                    </div>            
                }, 
            ],
            currentUser: props.currentUser,
        }
        this.showList = this.showList.bind(this);
        this.openDialogDownloadConstancyOfInscripcionActualizacion = this.openDialogDownloadConstancyOfInscripcionActualizacion.bind(this);
        this.closeDialogDownloadConstancyOfInscripcionActualizacion = this.closeDialogDownloadConstancyOfInscripcionActualizacion.bind(this);
    }  
    //   -------------------------------------
    async showList(){
        this.setState({data: []})
        try{
            this.setState({loading: true, checkAutorization: true});
            const hasPermission = await ApiServices.userSecurity.hasPermission('solicitudesDeEmpadronamiento','list');    
            if (hasPermission.error){
                this.setState({checkAutorization: false,authorized: false,loading: false });
            }else{
                ApiServices[this.state.controller].initSearchCriteria.clear();
                ApiServices[this.state.controller].initOrderCriteria.clear();
                // ApiServices[this.state.controller].orderCriteria.addDesc("fechaSolicitud");
                ApiServices[this.state.controller].initSearchCriteria.setOperator("and");              
                ApiServices[this.state.controller].initSearchCriteria.addEquals("datosSolicitudEmpadronamiento.statusSolicitud",1);  
                ApiServices[this.state.controller].initOrderCriteria.addDesc("datosSolicitudEmpadronamiento.idSolicitud"); 
                // let response =  await ApiServices[this.state.controller].listRegisterCriteria();
                // let data= [];
                // if (response.error!==null)      Alert.error(response.error.message);
                // else if (response.data!=="")   data= response.data;            
                this.setState({checkAutorization: false, authorized: true,loading: false,data: [], create: false });
            }
        }catch(exception){
            (exception.status===404) ? Alert.error("Falla del sistema"): Alert.error("Intente de nuevo ");
            this.setState({ loading: false,checkAutorization: false  });
        }
    }
    openDialogDownloadConstancyOfInscripcionActualizacion(data){
        // console.log('data: ', data)
        this.setState({
            saveDataDescargarConstancia: {idSolicitud: data.idSolicitud, cui: data.datosDpiSolicitudEmpadronamiento.cui, nroBoleta: data.nroboleta, password:''},
            origenSolicitud: 'Descargar Constancia de '+data.datosSolicitudEmpadronamiento.tipoSolicitud+', origen '+data.datosSolicitudEmpadronamiento.tipoOrigen,
            descargarConstanciaDeEmpadronamientoEmergencia: true
        })
    }
    closeDialogDownloadConstancyOfInscripcionActualizacion(){
        this.setState({descargarConstanciaDeEmpadronamientoEmergencia: false})
    }
    async componentDidMount() {  
        await this.showList();
    }
    
    render() {
        if (this.state.checkAutorization ) return <LoadingSpinner open={this.state.loading}/> 
        return (
            <div>
                <DialogLoadingMessage open={this.state.loadingMessage.loading} title={this.state.loadingMessage.title}/>
                {this.state.loading ? <LoadingSpinner open={this.state.loading}/> : ""}
                <ComponenteDescargarConstanciaEmergencia 
                    open={this.state.descargarConstanciaDeEmpadronamientoEmergencia}
                    handleClose={this.closeDialogDownloadConstancyOfInscripcionActualizacion}
                    titleDialog = {this.state.origenSolicitud}
                    saveDataDescargarConstancia={this.state.saveDataDescargarConstancia}
                />
                {window.screen.width >= 1024 ? (
                    <Table  pageSize={this.state.pageSize}
                            service={ApiServices[this.state.controller]}
                            title={"Listado de solicitudes aprobadas"}
                            header = {this.state.header} 
                            data={this.state.data} 
                            refreshList={this.showList}
                            detailPanel={this.state.detailPanel}
                            addRegister={this.addRegister}
                            showSearcher={false}
                            showFilterGeneral={false}
                    />
                ) : (<ListElement/>) }
                <br/><br/><br/><Footer />
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SolicitudesEnviadas);